<div class="{{type}}-rating">
    <div class="reviews-wrapper">
        <img class="{{type}}-logo" src="{{logo}}">
        <div *ngIf="reviewsCount" class="ng-hotel-reviews">
            {{ reviewsCount }} {{ reviewsCountLabel }}
        </div>
    </div>

    <span class="rating-value">{{ hotelRating }}</span>
</div>